module.exports = __webpack_public_path__ + "img/2.14b1504c.png";